export default function FinalCTA() {
  const scrollToChooser = () => {
    const element = document.getElementById('chooser');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative py-20 bg-gradient-to-b from-[#0a1628] to-[#000000] overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(220, 38, 38, 0.1) 35px, rgba(220, 38, 38, 0.1) 70px)'
        }}></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        {/* Icon */}
        <div className="mb-8 flex justify-center">
          <div className="w-24 h-24 bg-[#DC2626] rounded-full flex items-center justify-center shadow-2xl animate-pulse">
            <i className="ri-shield-flash-fill text-5xl text-white"></i>
          </div>
        </div>

        {/* Headline */}
        <h2 className="text-5xl md:text-7xl font-black text-white mb-8 leading-tight" style={{ fontFamily: "'Roboto', sans-serif" }}>
          FLIP THE<br />
          <span className="text-[#DC2626]">POWER DYNAMIC</span>.
        </h2>

        {/* Subheadline */}
        <p className="text-2xl md:text-3xl text-gray-300 mb-12 max-w-3xl mx-auto font-medium">
          You can keep being a target.<br />
          Or you can <span className="text-white font-bold">get the Shield</span>.
        </p>

        {/* Business Plan Notice */}
        <div className="mb-8 max-w-3xl mx-auto">
          <div className="bg-yellow-400/10 border-2 border-yellow-400 rounded-lg px-6 py-4">
            <div className="flex items-center justify-center gap-3 flex-wrap">
              <i className="ri-building-fill text-2xl text-yellow-400"></i>
              <p className="text-lg md:text-xl text-white font-bold">
                Protecting Rental Properties? Select the <span className="text-yellow-400">Business Plan</span> or <span className="text-yellow-400">Home Business Supplement</span> at checkout.
              </p>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <div className="flex flex-col items-center gap-6 mb-16">
          <button
            onClick={scrollToChooser}
            className="inline-flex items-center gap-3 bg-[#DC2626] hover:bg-[#B91C1C] text-white font-black text-xl md:text-2xl px-12 py-6 rounded-lg transition-all duration-300 shadow-2xl hover:shadow-[#DC2626]/50 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            ACTIVATE MY SHIELD
            <i className="ri-arrow-right-line text-3xl"></i>
          </button>
          <span className="text-base text-gray-400 italic">Direct Access. No Middlemen.</span>
        </div>

        {/* Value Props */}
        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-[#0f1d2e]/50 border border-[#DC2626]/30 rounded-lg p-6">
            <i className="ri-flashlight-fill text-4xl text-[#DC2626] mb-3"></i>
            <p className="text-white font-bold text-lg mb-2">Instant Activation</p>
            <p className="text-gray-400 text-sm">Coverage begins immediately after signup</p>
          </div>
          <div className="bg-[#0f1d2e]/50 border border-[#DC2626]/30 rounded-lg p-6">
            <i className="ri-money-dollar-circle-fill text-4xl text-[#DC2626] mb-3"></i>
            <p className="text-white font-bold text-lg mb-2">Affordable Power</p>
            <p className="text-gray-400 text-sm">Less than a tank of gas per month</p>
          </div>
          <div className="bg-[#0f1d2e]/50 border border-[#DC2626]/30 rounded-lg p-6">
            <i className="ri-scales-3-fill text-4xl text-[#DC2626] mb-3"></i>
            <p className="text-white font-bold text-lg mb-2">Real Attorneys</p>
            <p className="text-gray-400 text-sm">Top-tier law firms on your side</p>
          </div>
        </div>
      </div>
    </section>
  );
}
